<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        class="mb-5"
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <a-table :dataSource="result" :columns="columns" :pagination="false" >
          <span slot="group" slot-scope="text,record">
            {{ record[groupByFilters(form.getFieldValue('group_by'))] }}
          </span>
            <span slot="groupByColumns">
            Group By({{ setGroupColumn() }})
          </span>
            <span v-for="slot in slotCustoms" :slot="slot.slot" slot-scope="text,record">
                <div class="flex flex-col gap-y-1">
                  <div>{{ record[slot.field]['count'] }}</div>
                  <small>Time actual  : {{ hasFloatTime(record[slot.field]['actual']) + ' h'   }}</small>
                  <small>Time estimate: {{ hasFloatTime(record[slot.field]['estimate']) + ' h' }}</small>
                </div>
            </span>
          </a-table>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <SelectOption
            url="/account/list/"
            label="User"
            field="user"
            :required="false"
            method="get"
            placeholder="Find A User"
            class="w-full self-end"
          />
          <div class="flex flex-col md:flex-row">
            <selectSearch
              :required="false"
              url="/matter/query/"
              :options="optionSearchMatter"
              class="self-end mt-8 md:mt-0 w-full"
              :is_include_matter="true"
              @selectSearch="handleSearch"
            />
          </div>
          <a-form-item label="Task type">
            <a-select v-decorator="['status',{ rules: [{ required: false, message: 'this field is required.' }] }]" allowClear>
              <a-select-option :value="1">
                Pending
              </a-select-option>
              <a-select-option :value="2">
                In progress
              </a-select-option>
              <a-select-option :value="3">
                In review
              </a-select-option>
              <a-select-option :value="4">
                Complete
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Group Results By">
            <a-select v-decorator="['group_by',{initialValue: 1,rules: [{ required: false }] }]">
              <a-select-option :value="1">
                Client
              </a-select-option>
              <a-select-option :value="2">
               Assign User
              </a-select-option>
              <a-select-option :value="3">
                Matter
              </a-select-option>
            </a-select>
          </a-form-item>
          <DateRangeComponent :dateForm="form" class="mt-5"/>
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','TaskReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>
import DateRangeComponent from "@/components/date/DateRangeComponent";
import mixin from '../../mixin/mixin'
import SelectOption from "@/views/forms/SelectOptionSingle";
import SelectSearch from "@/views/forms/selectSearch";
import axios from "@/axios";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columns = [
  {
    dataIndex: 'group_by',
    key: '1',
    slots: { title: 'groupByColumns' },
    scopedSlots: {customRender: 'group'},
  },
  {
    title: 'Pending',
    dataIndex: 'pending',
    key: '2',
    scopedSlots: {customRender: 'pending'},
  },
  {
    title: 'Progress',
    dataIndex: 'progress',
    key: '3',
    scopedSlots: {customRender: 'progress'},
  },
  {
    title: 'Review',
    dataIndex: 'review',
    key: '4',
    scopedSlots: {customRender: 'review'},
  },
  {
    title: 'Completed',
    dataIndex: 'completed',
    key: '5',
    scopedSlots: {customRender: 'completed'},
  },
  {
    title: 'Total Tasks',
    dataIndex: 'total_task',
    key: '6',
    scopedSlots: {customRender: 'total'},
  },
]

export default {
  name: "ComponentProgressByUser",
  components: {Actions, SelectSearch, SelectOption, DateRangeComponent,ExportPdf,BtnSubmitReport},
  mixins: [mixin],
  data(){
    return {
      columns,
      title: 'Task Progress',
      slotCustoms: [
        { slot: 'pending'  , field: 'pending'    },
        { slot: 'progress' , field: 'in_progress'},
        { slot: 'review'   , field: 'in_review'  },
        { slot: 'completed', field: 'completed'  },
        { slot: 'total'    , field: 'total_tasks'},
      ]
    }
  },
  methods: {
    handleReport() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.$refs.reportSubmit.loading = true
            const query = []
            if (values.status) query.push({field: 'status', condition: '=', value: values.status, operation: 'and'})
            if (values.matter) query.push({field: 'matter', condition: '=', value: values.matter, operation: 'and'})
            if (values.user && values.user.length) query.push({field: 'assigned_user__id', condition: 'in', value: values.user, operation: 'and'})
            if (values.from_date && values.to_date) query.push({ field:'created_at', condition: '>=', value: values.from_date },{ field:'created_at', condition: '<=', value: values.to_date })
            const {data} = await axios.post('task/report/by-user', {group_by: values.group_by , query: query.length ? query : undefined})
            this.visibleRes = true
            this.result = Object.values(data)
          } catch (err) {
            this.visibleRes = false
            this.$message.error('Server Error')
            throw new Error(err)
          } finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    },
    groupByFilters(group) {
      if (group === 1) return 'client'
      if (group === 2) return 'assigned_user'
      if (group === 3) return 'matter'
    },
    hasFloatTime(num) {
      if (Number(num) === num && num % 1 !== 0) return num.toFixed(2)
      return num
    },
    setGroupColumn() {
      const group = this.form.getFieldValue('group_by')
      if (group) {
        if (group === 1) return 'Client'
        if (group === 2) return 'Assign User'
        if (group === 3) return 'Matter'
      }
    }
  }
}
</script>
